import apiFetch from "../../../../shared/services/apiClient";

export async function getReceipts(page) {
  const res = await apiFetch(`/api/finance/recibo?page=${page}`);
  return res.json();
}

export async function downloadPDF(filters) {
  const res = await apiFetch("/api/core/pdf/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(filters),
  });

  return res.blob();
}
